<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-05-14 15:36:44
 * @LastEditTime : 2025-06-10 11:56:50
 * @LastEditors  : yangxr
 * @Description  : 进销存明细
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\docking\incomeSheet\saleMonthReportDetail.vue
-->
<template>
    <div class="main-container">
        <el-container>
            <el-main style="padding:10px 20px; 0">
                <div v-loading="tableLoading" :style="style">
                    <tableMain ref="tableMain" key="1" :tableData="tableData" :height="isIcps ? fullHeight -150 :fullHeight - 20" :tableHead="tableHead" />
                </div>
            </el-main>
        </el-container>
    </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import tableMain from "./tableMain.vue";
import { queryDetailBasicData, queryIncomeCheckDetailData } from "@/api/docking.js";
export default {
    components: {
        tableMain,
    },
    mixins: [mixin],
    data() {
        return {
            tableData: [],
            tableHead: [],
            pagesType: 0,
            fullHeight:0,
            isIcps:false,
        };
    },
    async created() {
        this.fullHeight = document.documentElement.clientHeight;
        const query = this.$route.query
        console.log(query)
        if (query.isIcps) {
            this.isIcps = true
            this.getTableData(query.code)
        } else {
            this.isIcps = false
            this.getTableData2(query.code)
        }

    },
    mounted() {
    },
    watch: {
    },
    methods: {
        //明细对账单详情获取数据
        async getTableData(code) {
            let res = await queryDetailBasicData({ sheetDatialId: code })
            if (res.code == 1001) {
                res.data.sort((a, b) => {
                    // 依次比较站点、时间、主体、大类
                    // if (a.stationName !== b.stationName) {
                    //   return a.stationName.localeCompare(b.stationName);
                    // }
                    // if (a.businessTime !== b.businessTime) {
                    //   return a.businessTime.localeCompare(b.businessTime);
                    // }
                    // if (a.mianBodyName !== b.mianBodyName) {
                    //   return a.mianBodyName.localeCompare(b.mianBodyName);
                    // }
                    return a.engineeringId.localeCompare(b.engineeringId);
                });
                let tableHead = []
                let tableData = []
                res.data.forEach(item => {
                    //提取站点表头
                    let headObj = { label: item.settleStationName, prop: item.settleStationName + 'quantity', status: true, width: "70" }
                    if (!tableHead.some(item2 => item2.label === item.settleStationName)) {
                        tableHead.push(headObj)
                    }
                    //合并表格数据
                    const index = tableData.findIndex(item2 =>
                        item2.engineeringId === item.engineeringId && item2.productName === item.productName
                    );
                    if (index == -1) {
                        let obj = item
                        obj['quantityAll'] = obj.quantity
                        obj['taxInclusiveAmountAll'] = obj.taxInclusiveAmount
                        obj[item.settleStationName + 'quantity'] = obj.quantity
                        tableData.push(item)
                    } else {
                        tableData[index]['quantityAll'] = tableData[index]['quantityAll'] + item.quantity
                        tableData[index]['taxInclusiveAmountAll'] = tableData[index]['taxInclusiveAmountAll'] + item.taxInclusiveAmount
                        tableData[index][item.settleStationName + 'quantity'] = item.quantity
                    }
                });
                this.tableData = tableData
                this.tableHead = tableHead
                console.log(this.tableHead)
            }
        },
        //明细对账单详情获取数据-共享
        async getTableData2(code) {
            let res = await queryIncomeCheckDetailData({ code: code })
            if (res.code == 1001) {
                res.data.sort((a, b) => {
                    return a.engineeringId.localeCompare(b.engineeringId);
                });
                let tableHead = []
                let tableData = []
                res.data.forEach(item => {
                    //提取站点表头
                    let headObj = { label: item.settleStationName, prop: item.settleStationName + 'quantity', status: true, width: "70" }
                    if (!tableHead.some(item2 => item2.label === item.settleStationName)) {
                        tableHead.push(headObj)
                    }
                    //合并表格数据
                    const index = tableData.findIndex(item2 =>
                        item2.engineeringId === item.engineeringId && item2.productName === item.productName
                    );
                    if (index == -1) {
                        let obj = item
                        obj['quantityAll'] = obj.quantity
                        obj['taxInclusiveAmountAll'] = obj.taxInclusiveAmount
                        obj[item.settleStationName + 'quantity'] = obj.quantity
                        tableData.push(item)
                    } else {
                        tableData[index]['quantityAll'] = tableData[index]['quantityAll'] + item.quantity
                        tableData[index]['taxInclusiveAmountAll'] = tableData[index]['taxInclusiveAmountAll'] + item.taxInclusiveAmount
                        tableData[index][item.settleStationName + 'quantity'] = item.quantity
                    }
                });
                this.tableData = tableData
                this.tableHead = tableHead
                console.log(this.tableHead)
            }
        },
    }
};
</script>
<style lang="scss" scoped>
.main-container {
    background: #fff;
}
</style>